import { Popover, ActionIcon, Avatar } from "rizzui";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { AuthContext } from "../../context/authContext";

export default function ProfileMenu({
  buttonClassName,
  avatarClassName,
  username = false,
}: {
  buttonClassName?: string;
  avatarClassName?: string;
  username?: boolean;
}) {
  const { profile } = useContext(AuthContext);

  return (
    <ProfileMenuPopover>
      <Popover.Trigger>
        <ActionIcon className="!bg-transparent !p-0">
          {profile?.firstname && (
            <Avatar
              name={`${profile?.firstname} ${profile?.lastname}`}
              customSize={38}
              className="text-[14px] text-[#191919]"
            />
          )}
        </ActionIcon>
      </Popover.Trigger>

      <Popover.Content className="z-[9999] p-0 dark:bg-[#2A2C30] [&>svg]:dark:fill-[#2A2C30]">
        <DropdownMenu />
      </Popover.Content>
    </ProfileMenuPopover>
  );
}

function ProfileMenuPopover({ children }: React.PropsWithChildren<{}>) {
  const pathname = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  return (
    <Popover
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      shadow="sm"
      placement="bottom-end"
    >
      {children}
    </Popover>
  );
}

const menuItems = [
  {
    name: "Settings",
    href: "/settings",
  },
  {
    name: "Sign out",
    href: "/account/logout",
  },
];

function DropdownMenu() {
  return (
    <div className="w-[220px] text-left rtl:text-right">
      <div className="grid p-[8px] text-[14px] font-[400] leading-[22px] font-switzer">
        {menuItems.map((item) => (
          <a
            key={item.name}
            href={item.href}
            className="group px-3.5 p-[16px] h-[44px] text-primary-dark flex items-center rounded-md hover:bg-gray-100 focus:outline-none hover:dark:bg-gray-50/50"
          >
            {item.name}
          </a>
        ))}
      </div>
    </div>
  );
}
